import type { ConcreteComponent, ComponentInternalInstance } from 'vue'

type ConcreteComponentWithScopeId = ConcreteComponent & {
  __scopeId: string | undefined
}

function getParentId(
  instance: ComponentInternalInstance | null,
  id: string[]
): string[] {
  const instanceId = (instance?.type as ConcreteComponentWithScopeId).__scopeId

  if (instance?.parent) {
    const parentsId = getParentId(instance.parent, id)

    return instanceId
      ? [...id, instanceId, ...parentsId]
      : [...id, ...parentsId]
  }

  return instanceId ? [...id, instanceId] : id
}

export function useScopeId() {
  const parentsScopedId = ref<string[]>([])

  const parentsScopedIdAttribute = computed((): Record<string, boolean> => {
    return parentsScopedId.value.reduce(
      (pre, cur) => {
        pre[cur] = true

        return pre
      },
      {} as Record<string, boolean>
    )
  })

  onMounted(() => {
    parentsScopedId.value = getParentId(getCurrentInstance(), [])
  })

  return {
    parentsScopedIdAttribute,
    parentsScopedId
  }
}
